import $ from 'jquery';
import Swal from 'sweetalert2';

export default function () {
    init();
    searchBrand();
    sortProducts();
    sortBrand();
    sortCategory();
    removeFilter();
    loadMoreCategories();
    loadMoreBrands();
}

function init()
{
    if($('.js-remove-filter[data-filter-type=brand]').length)
    {
        const brandName = $('[name=brand]:checked').data('brand-name');
        $('.js-remove-filter[data-filter-type=brand] > span').text(brandName);
    }
}

function removeFilter()
{
    $('.js-remove-filter').on('click', function(e){
        e.preventDefault();
        
        const filterType = $(this).data('filter-type');
        if(filterType)
        {
            let url = new URL(window.location.href);
            url.searchParams.delete(filterType);
            window.location.href = url;   
        }
    })
}

function searchBrand() 
{
    $('.js-search-brand').on('keyup', function (e) {
        e.preventDefault();

        const val = $(this).val().toLowerCase();
        console.log(val)
        $('.js-brand-item-wrapper').addClass('d-none');
        $.each($('.js-brand-item-wrapper'), function (i, e) {
            var b = $(e).data('brand-name').toLowerCase();

            if (b.includes(val)) {
                $(e).removeClass('d-none')
            }
        })

    })
}

function sortProducts() 
{
    $('.js-select-sort').on('change', function(e) {
        e.preventDefault();
        const sort = $(this).val();
        
        if(sort == '-1')
        {
            let url = new URL(window.location.href);
            url.searchParams.delete('sort');
            window.location.href = url;
        }

        if(sort && sort != '-1')
        {
            let url = new URL(window.location.href);
            url.searchParams.set('sort', sort);
            window.location.href = url;
        }
    })
}

function sortBrand()
{
    $('.js-brand-item').on('click', function(e) {
        e.preventDefault();
        
        const brand = $(this).val();

        if(brand)
        {
            let url = new URL(window.location.href);
            url.searchParams.set('brand', brand);
            window.location.href = url;
        }
    });
}

function sortCategory()
{
    $('.js-category-item').on('click', function(e){
        e.preventDefault();
        
        const category = $(this).data('category-slug');

        if(category)
        {
            let url = new URL(window.location.href);
            url.searchParams.set('category', category);
            window.location.href = url;
        }
    })
}

function loadMoreCategories()
{
    const perShow = 10;
    $('.js-ps-list--categories li')
        .slice(0, perShow)
        .show();

    $('.js-show-categories').on('click', function(e){
        e.preventDefault();
        $('.js-ps-list--categories li:hidden')
            .slice(0, perShow)
            .slideDown();

        if(!$('.js-ps-list--categories li:hidden').length) 
            $('.js-show-categories').addClass('d-none')
    })
}

function loadMoreBrands()
{
    const perShow = 10;
    $('.js-brand-item-wrapper')
        .slice(0, perShow)
        .show();

    $('.js-show-brands').on('click', function(e){
        e.preventDefault();
        $('.js-brand-item-wrapper:hidden')
            .slice(0, perShow)
            .slideDown();

        if(!$('.js-brand-item-wrapper').length) 
            $('.js-show-brands').addClass('d-none')
    })
}